import {TOption} from './TOption'

export const SO_STATUS: TOption[] = [
  {value: '0', label: 'Menunggu Persetujuan'},
  {value: '1', label: 'Proses Persetujuan'},
  {value: '2', label: 'Revisi'},
  {value: '5', label: 'Menunggu SO'},
  {value: '6', label: 'SO Terbit'},
  {value: '7', label: 'Selesai'},
  {value: '9', label: 'Menunggu Pembayaran'},
  {value: '10', label: 'Proses Pengambilan'},
  {value: '13', label: 'SAP Error'},
  {value: '14', label: 'Diamandemen Customer'},
  {value: '90', label: 'Ditolak'},
  {value: '91', label: 'Batal'},
  {value: '99', label: 'Expired'},
]
